import { Component } from '@angular/core';
import { IonicPage, ModalController, NavController, ToastController, NavParams, AlertController, ViewController} from 'ionic-angular';
import { RestProvider } from '../../providers/rest/rest';
import { HttpClient} from '@angular/common/http';
import { DataProvider } from '../../providers/data/data';
import { DashboardPage } from '../dashboard/dashboard';

@IonicPage()
@Component({
  selector: 'page-customers',
  templateUrl: 'customers.html',
})
export class CustomersPage {
  private GetUsers = [];
  private getTypes = [];
  private getStatuses = [];
  private type: any;
  private jobs = [];
  private deleteUser = [];
  private editUserVerify: any;
  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    private modalCtrl: ModalController,
    public alertCtrl: AlertController,
    private rest: RestProvider,
    private data: DataProvider,
    private toastCtrl: ToastController,
    public httpClient: HttpClient,
    ) {

  }
  ionViewDidLoad() {
    document.getElementById('backmenu').style.display = 'block';
    document.getElementById('backFrom').innerText = '';
    this.data.currentTabName = 'Ажилчид';

    this.users();
    this.rest.getStatuses(this.data.companyId).subscribe(res => {
      this.getStatuses = res;
    });
    this.rest.jobs(this.data.companyId).subscribe(res => {
      this.jobs = res;
    });
  }
  update( user: any) {
    if(confirm('Та энэ хэрэглэгчийн бүртгэлийг хаахдаа итгэлтэй байна уу?')) {
      this.rest.deleteUser(user.id).subscribe(res => {
        this.deleteUser = res;
        this.showToast('Таны сонгосон хэрэглэгчийн бүртгэлийг амжилттай хаалаа.');
        this.users();
      });
    }

  }

  users() {
    this.rest.GetUsers(this.data.companyId).subscribe(res => {
      this.GetUsers = res;
    });
  }
  set(user: any){
    let setUserInfo = this.modalCtrl.create(
      ModalSetUserInfoPage,
      { user: user },
      {
        showBackdrop: false,
     enableBackdropDismiss: true
    }
    );
    setUserInfo.present().catch(err => {

    });
    setUserInfo.onDidDismiss((data) => {
      if(data != null) {
        this.users();
      }
    });
  }
  setVerify(user: any){
    if(confirm('Та энэ хэрэглэгчийн бүртгэлийг баталгаажуулахдаа итгэлтэй байна уу?')) {
      this.rest.editUserVerify(user.id).subscribe(res => {
        this.editUserVerify = res;
        this.showToast('Таны сонгосон хэрэглэгчийн бүртгэлийг амжилттай баталгаажууллаа.');
        this.users();
      });
    }
  }
  showToast(str: any) {
    let toast = this.toastCtrl.create({
      message: str,
      position: 'middle',
      duration: 5000,
      cssClass: "toast-success"
    });
    toast.present();
  }
  showToast1(str: any) {
    let toast = this.toastCtrl.create({
      message: str,
      position: 'middle',
      duration: 5000,
      cssClass: "toast-unsuccess"
    });
    toast.present();
  }
}

@Component({
  template: `
  <ion-header text-center style="height: 50px; background-color: #84dac8;">
    <ion-title>Хэрэглэгч {{user.firstname}} -ийн мэдээлэл</ion-title>
  </ion-header>
  <ion-content text-center>
    <ion-grid>
    <ion-row>
      <ion-col col-sm-3 col-xl-3 col-md-3 col-lg-3>
      </ion-col>
      <ion-col text-center col-sm-6 col-xl-6 col-md-6 col-lg-6>
        <ion-item>
          <ion-label floating>Харъяалагдах байгууллага</ion-label>
          <ion-select [(ngModel)]="companyId">
              <ion-option *ngFor="let company of companys" value="{{company.id}}">{{company.name}}</ion-option>
          </ion-select>
        </ion-item>
      </ion-col>
      <ion-col col-sm-3 col-xl-3 col-md-3 col-lg-3>
      </ion-col>
    </ion-row>

    <ion-row>
      <ion-col col-sm-3 col-xl-3 col-md-3 col-lg-3>
      </ion-col>
      <ion-col text-center col-sm-6 col-xl-6 col-md-6 col-lg-6>
          <ion-item>
          <ion-label floating>Системд хандах эрх</ion-label>
          <ion-select [(ngModel)]="typeId">
              <ion-option *ngFor="let jobType of getTypes.types" value="{{jobType.id}}">{{jobType.value}}</ion-option>
          </ion-select>
        </ion-item>
      </ion-col>
      <ion-col col-sm-3 col-xl-3 col-md-3 col-lg-3>
      </ion-col>
    </ion-row>


<ion-row>
  <ion-col col-sm-3 col-xl-3 col-md-3 col-lg-3>
  </ion-col>
  <ion-col text-center col-sm-6 col-xl-6 col-md-6 col-lg-6>
    <ion-item>
      <ion-label>Эрхэлдэг албан тушаал</ion-label>
      <ion-select [(ngModel)]="jobId">
        <ion-option *ngFor="let job of jobs" value="{{job.id}}">{{job.val}}</ion-option>
      </ion-select>
  </ion-item>
  </ion-col>
  <ion-col col-sm-3 col-xl-3 col-md-3 col-lg-3>
  </ion-col>
</ion-row>

<ion-row>
      <ion-col col-sm-3 col-xl-3 col-md-3 col-lg-3>
      </ion-col>
      <ion-col text-center col-sm-6 col-xl-6 col-md-6 col-lg-6>
          <ion-item>
          <ion-label floating>Статус</ion-label>
          <ion-select [(ngModel)]="statusId">
              <ion-option *ngFor="let status of getStatuses" value="{{status.id}}">{{status.title}}</ion-option>
          </ion-select>
        </ion-item>
      </ion-col>
      <ion-col col-sm-3 col-xl-3 col-md-3 col-lg-3>
      </ion-col>
    </ion-row>

<ion-row>
  <ion-col col-sm-3 col-xl-3 col-md-3 col-lg-3>
  </ion-col>
  <ion-col text-center col-sm-6 col-xl-6 col-md-6 col-lg-6>
    <ion-item>
      <ion-label>Нэр</ion-label>
      <ion-input type="text" [(ngModel)]="userName"></ion-input>
  </ion-item>
  </ion-col>
  <ion-col col-sm-3 col-xl-3 col-md-3 col-lg-3>
  </ion-col>
</ion-row>

<ion-row>
      <ion-col col-sm-3 col-xl-3 col-md-3 col-lg-3>
        </ion-col>
      <ion-col text-center col-sm-6 col-xl-6 col-md-6 col-lg-6>
          <ion-item>
          <ion-label floating>И-мэйл хаяг</ion-label>
          <ion-input [(ngModel)]="email" type="text" [readonly]="isReadonly"></ion-input>
        </ion-item>
      </ion-col>
      <ion-col col-sm-3 col-xl-3 col-md-3 col-lg-3>
        </ion-col>
 </ion-row>

 <ion-row>
      <ion-col col-sm-3 col-xl-3 col-md-3 col-lg-3>
        </ion-col>
      <ion-col text-center col-sm-6 col-xl-6 col-md-6 col-lg-6>
        <ion-item>
        <ion-label>Ажиллаж эхэлсэн он</ion-label>
        <!--<ion-input [(ngModel)]="workYearStart" type="text"></ion-input>-->
        <ion-datetime displayFormat="YYYY/MM/DD" [(ngModel)]="workYearStart"></ion-datetime>
        </ion-item>
      </ion-col>
      <ion-col col-sm-3 col-xl-3 col-md-3 col-lg-3>
        </ion-col>
</ion-row>

<ion-row>
      <ion-col col-sm-3 col-xl-3 col-md-3 col-lg-3>
        </ion-col>
      <ion-col text-center col-sm-6 col-xl-6 col-md-6 col-lg-6>
      <ion-label>Тухайн байгууллагад ажилд орсон он</ion-label>
        <ion-item>
        <!--<ion-input [(ngModel)]="workYearIn" type="text" [readonly]="isReadonly"></ion-input>-->
        <ion-datetime displayFormat="YYYY/MM/DD" [(ngModel)]="workYearIn" disabled></ion-datetime>
        </ion-item>
      </ion-col>
      <ion-col col-sm-3 col-xl-3 col-md-3 col-lg-3>
        </ion-col>
</ion-row>

<ion-row>
      <ion-col col-sm-3 col-xl-3 col-md-3 col-lg-3>
        </ion-col>
      <ion-col text-center col-sm-6 col-xl-6 col-md-6 col-lg-6>
        <ion-label>Ажилласан жил</ion-label>
        <ion-item>
        <ion-input type="text" [readonly]="isReadonly" [(ngModel)]="workYear"></ion-input>
        </ion-item>
      </ion-col>
      <ion-col col-sm-3 col-xl-3 col-md-3 col-lg-3>
        </ion-col>
</ion-row>


<ion-row>
  <ion-col col-sm-3 col-xl-3 col-md-3 col-lg-3>
  </ion-col>
  <ion-col text-center col-sm-3 col-xl-3 col-md-3 col-lg-3>
    <ion-item>
      <button class="myButton" (click)="settingTask()">Засах</button>
    </ion-item>
  </ion-col>
  <ion-col text-center col-sm-3 col-xl-3 col-md-3 col-lg-3>
    <ion-item>
    <button class="myButton" (click)="back()">Буцах</button>
    </ion-item>
  </ion-col>
  <ion-col col-sm-3 col-xl-3 col-md-3 col-lg-3>
  </ion-col>
</ion-row>

</ion-grid>
</ion-content>
  `
})

export class  ModalSetUserInfoPage {
  private GetUsers = [];
  private getTypes = [];
  private jobId: any;
  public companys = [];
  private jobs = [];
  private getStatuses = [];
  private companyId: any;
  private userName: any;
  private workYear: any;
  private email: any;
  private workYearIn: any;
  private workYearStart: any;
  private val: any;
  private erh: any;
  private user: any;
  private editUser: any;
  private statuses: any;
  private type: any;
  private statusId: any;
  private typeId: any;
  private userId: any;
  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public alertCtrl: AlertController,
    private rest: RestProvider,
    public httpClient: HttpClient,
    private viewCtrl: ViewController,
    private toastCtrl: ToastController,
    private data: DataProvider,){
      this.user = this.navParams.get('user');
    if(this.user != null) {
      this.userId = this.user.id;
      this.userName = this.user.firstname;
      this.companyId = this.user.company_id;
      this.erh = this.user.erh;
      this.email = this.user.email;
      this.workYear = this.user.work_year;
      this.workYearIn = this.user.work_year_in;
      this.workYearStart  = this.user.work_year_start;
      this.jobId = this.user.job_id;
      this.statusId = this.user.status_id;
      this.typeId = this.user.type_id;
    }
      this.users();      
    }
  users() {
    this.rest.GetUsers(this.data.companyId).subscribe(res => {
      this.GetUsers = res;
      this.rest.getTypes(this.data.companyId).subscribe(res => {
        this.getTypes = res;
        this.rest.companys().subscribe(res => {
          this.companys = res;
          this.rest.getStatuses(this.data.companyId).subscribe(res => {
            this.getStatuses = res.statuses;
            this.rest.jobs(this.companyId).subscribe(res => {
              this.jobs = res;
            });
          });          
        });        
      });      
    });
  }
  settingTask() {
    if( !this.userName ){
      this.userName == null;
      this.showToast1('Нэр бичигдээгүй байна!!!');
      return;
    }
    if( !this.statusId ){
      this.userName == null;
      this.showToast1('Статус сонгогдоогүй байна!!!');
      return;
    }
    if( !this.jobId ){
      this.jobId == null;
      this.showToast1('Албан тушаал сонгогдоогүй байна!!!');
      return;
    }
    if( !this.erh ){
      this.erh == null;
      this.showToast1('Системд хандах эрх сонгогдоогүй байна!!!');
      return;
    }
    if( !this.workYearStart ){
      this.workYearStart == null;
      this.showToast1('Ажил эхэлсэн өдөр бичигдээгүй байна!!!');
      return;
    }
    this.rest.editUser(this.userId, this.userName, this.jobId, this.typeId, this.statusId, this.workYearStart).subscribe(res => {
      this.editUser = res;
      this.showToast('Таны сонгосон ажилтны мэдээллийг өөрчиллөө.');
      this.viewCtrl.dismiss({});
      this.users();
    });
  }
  back(){
    this.viewCtrl.dismiss({});
  }

  isReadonly() {
    return true;
  }
  showToast(str: any) {
    let toast = this.toastCtrl.create({
      message: str,
      position: 'middle',
      duration: 5000,
      cssClass: "toast-success"
    });
    toast.present();
  }
  showToast1(str: any) {
    let toast = this.toastCtrl.create({
      message: str,
      position: 'middle',
      duration: 5000,
      cssClass: "toast-unsuccess"
    });
    toast.present();
  }
}



// WEBPACK FOOTER //
// ./src/pages/customers/customers.ts